import { UPDATE_CURRENT_APP_VERSION, UPDATE_TENANT_CONFIG, UPDATE_TENANT_CONFIG_ERROR, UPDATE_TENANT_CONFIG_SUCCESS, } from '../../constants';
export var Platform;
(function (Platform) {
    Platform["IOS"] = "ios";
    Platform["ANDROID"] = "android";
})(Platform || (Platform = {}));
export const APP_UPDATE_INITIAL_STATE = {
    currentAppVersion: null,
    appUpdate: {
        majorVersion: null,
        minorVersion: null,
    },
    loading: false,
    error: false,
};
const appUpdateReducer = (state = APP_UPDATE_INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_CURRENT_APP_VERSION:
            return {
                ...state,
                currentAppVersion: action?.version,
            };
        case UPDATE_TENANT_CONFIG:
            return {
                ...state,
                loading: true,
                error: false,
            };
        case UPDATE_TENANT_CONFIG_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                appUpdate: {
                    majorVersion: action.response?.platform === Platform.IOS
                        ? action.response?.iosmajorversion
                        : action.response?.androidmajorversion,
                    minorVersion: action.response?.platform === Platform.IOS
                        ? action.response?.iosminorversion
                        : action.response?.androidminorversion,
                },
            };
        case UPDATE_TENANT_CONFIG_ERROR:
            return {
                ...state,
                loading: false,
                error: true,
            };
        default:
            return state;
    }
};
export default appUpdateReducer;
